import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../styles/error.css';

const ErrorFallback = ({ error, errorInfo, onReset }) => {
  const [showDetails, setShowDetails] = useState(false);

  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = '/app';
  };

  const handleCopyError = () => {
    const errorText = `
Error: ${error?.toString()}

Stack Trace:
${error?.stack}

Component Stack:
${errorInfo?.componentStack}
    `.trim();

    navigator.clipboard.writeText(errorText).then(() => {
      alert('Error details copied to clipboard');
    });
  };

  return (
    <div className="error-fallback">
      <div className="error-container">
        <div className="error-icon">⚠️</div>
        
        <h1 className="error-title">Oops! Something went wrong</h1>
        
        <p className="error-message">
          We&apos;re sorry, but something unexpected happened. Don&apos;t worry, your data is safe.
        </p>

        <div className="error-actions">
          <button className="error-btn primary" onClick={onReset}>
            Try Again
          </button>
          <button className="error-btn secondary" onClick={handleGoHome}>
            Go to Home
          </button>
          <button className="error-btn secondary" onClick={handleReload}>
            Reload Page
          </button>
        </div>

        {error && (
          <div className="error-details-section">
            <button 
              className="error-details-toggle"
              onClick={() => setShowDetails(!showDetails)}
            >
              {showDetails ? '▼' : '▶'} Technical Details
            </button>

            {showDetails && (
              <div className="error-details">
                <div className="error-detail-block">
                  <strong>Error Message:</strong>
                  <pre>{error.toString()}</pre>
                </div>

                {error.stack && (
                  <div className="error-detail-block">
                    <strong>Stack Trace:</strong>
                    <pre>{error.stack}</pre>
                  </div>
                )}

                {errorInfo?.componentStack && (
                  <div className="error-detail-block">
                    <strong>Component Stack:</strong>
                    <pre>{errorInfo.componentStack}</pre>
                  </div>
                )}

                <button className="error-btn copy" onClick={handleCopyError}>
                  Copy Error Details
                </button>
              </div>
            )}
          </div>
        )}

        <p className="error-help-text">
          If this problem persists, please contact support with the error details above.
        </p>
      </div>
    </div>
  );
};

ErrorFallback.propTypes = {
  error: PropTypes.instanceOf(Error),
  errorInfo: PropTypes.shape({
    componentStack: PropTypes.string
  }),
  onReset: PropTypes.func.isRequired
};

ErrorFallback.defaultProps = {
  error: null,
  errorInfo: null
};

export default ErrorFallback;